import o from"styled-components";import{BodyCaption as r}from"../../../../TypographyStyle.js";import{COLORS as n}from"../../../../../constants/Theme.js";const e=o(r)`
	padding: 8px ${o=>"2.0"===o.version?12:16}px;
	color: ${o=>"2.0"===o.version?n.content.placeholder:n.content.secondary};
	background-color: ${o=>"2.0"===o.version?n.surface.standard:n.background.base};
	font-size: ${o=>"2.0"===o.version?10:12}px;
`;export{e as StyledGroupedLabel};
